<template>
  <v-card dark class="show qualification-type" v-if="qualificationType">
    <can I="read" a="QualificationType">
      <v-card-title primary-title>
        <div>
          <div class="headline">{{ qualificationType.name }}</div>
          <span class="subheading">{{ qualificationType.qualificationCategory.name }}</span>
        </div>
      </v-card-title>
      <v-divider />
      <!-- Attributes table -->
      <table class="v-table theme--dark">
        <tbody>
          <tr>
            <th class="text-xs-right">ID</th>
            <td>{{ qualificationType.id }}</td>
          </tr>
          <tr>
            <th class="text-xs-right">Category</th>
            <td>{{ qualificationType.qualificationCategory.name }}</td>
          </tr>
          <tr>
            <th class="text-xs-right">Name</th>
            <td>{{ qualificationType.name }}</td>
          </tr>
          <tr>
            <th class="text-xs-right">Acronym</th>
            <td v-if="qualificationType.acronym">
              {{ qualificationType.acronym }}
            </td>
            <td v-else><i>None</i></td>
          </tr>

          <tr>
            <th class="text-xs-right">Last updated</th>
            <td>
              {{ new Date(qualificationType.updatedAt) | date('h:mm a, MMMM do yyyy') }}
              ({{ new Date(qualificationType.updatedAt) | inWords({ addSuffix: true }) }})
            </td>
          </tr>

          <tr>
            <th class="text-xs-right">Created</th>
            <td>
              {{ new Date(qualificationType.createdAt) | date('h:mm a, MMMM do yyyy') }}
              ({{ new Date(qualificationType.createdAt) | inWords({ addSuffix: true }) }})
            </td>
          </tr>
        </tbody>
      </table>
      <v-divider />
      <v-card-actions><v-spacer />
        <can I="delete" a="QualificationType">
          <v-dialog v-model="dialog" lazy absolute max-width="600">
            <v-btn flat slot="activator" color="error">
              <v-icon left>mdi-delete</v-icon> Delete
            </v-btn>

            <v-card>
              <v-card-title class="headline">
                Are you sure?
              </v-card-title>
              <v-card-text>
                <p>
                  This action cannot be undone and will remove all associated
                  qualifications. This will unlink all profile qualifications
                  with this type or qualifications of this type.
                </p><p>
                  Side effects include: profile qualifications losing
                  qualification level information and disciplines.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn flat block color="grey" @click="dialog = false">cancel</v-btn>
                <v-btn block color="error" @click="destroy">Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </can>

        <can I="edit" a="QualificationType">
          <v-btn @click="$emit('edit')" color="primary">
            <v-icon left>mdi-pencil</v-icon> Edit
          </v-btn>
        </can>
      </v-card-actions>
    </can>
  </v-card>
</template>

<script>
// Vue Component
export default {
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    qualificationType() {
      return this.$store.getters['admin/qualificationTypes/find'](parseInt(this.$route.params.id))
    }
  },
  methods: {
    destroy() {
      this.$emit('destroy')
    }
  }
}
</script>
